import React from 'react';
import styled, { css } from 'styled-components';

import Section from '../Atoms/Section';
import Container from '../Atoms/Container';
import Row from '../Atoms/Row';
import Column from '../Atoms/Column';
import HighlightItem from './HighlightItem';
import Paragraph from '../Atoms/Paragraph';
import theme from '../../styles/theme';

const StyledContainer = styled(Container)`
  ${({ hasBg }) => hasBg && css`
    position: relative;
    background-image: linear-gradient(to top, #b0cfeb, #78a2d3);
    &:before {
      content: '';
      background: white;
      margin: 0 -16px;
      position: absolute;
      width: calc(100% + 32px);
      height: calc(100% + 16px);
      top: 0;
    }
    .columns {
      position: relative;
    }
  `}
`;

function HighlightListWithIcons({
  title, list, hasBg, ...rest
}) {
  return (
    <Section {...rest} background={hasBg ? theme.color.blue : theme.color.white}>
      <StyledContainer hasBg={hasBg}>
        {title && (
        <Row>
          <Column>
            <Paragraph fontSize={2} fontWeight={600} pb={0}>{title}</Paragraph>
          </Column>
        </Row>
        )}
        <Row>
          {list && list.map((point, index) => (
            <Column key={index}>
              <HighlightItem id={index} textAlign={hasBg ? 'left' : 'center'} {...point} />
            </Column>
          ))}
        </Row>
      </StyledContainer>
    </Section>
  );
}

export default HighlightListWithIcons;
